import React from 'react';
import { Button, List, ListItem, Link, useMediaQuery, IconButton, Container, Grid } from '@material-ui/core';
import {  makeStyles } from '@material-ui/styles';
import theme from '../theme';
import DrawerComponent from './drawerTest';
import globalUseStyles from '../styleHooks';
import logo from '../img/pantheon-logo-white.svg'
import { Link as RouterLink, NavLink } from 'react-router-dom';


const useStyle = makeStyles(() => ({
   spacing: {
       paddingTop: 10,
       paddingBottom: 20,
       [theme.breakpoints.down('md')]: {
        paddingTop: 15,
        paddingBottom: 10,
         },
   },
   
    buttonActive: {
       color: 'white',
       textTransform: 'uppercase',
       fontSize: 13,
       borderRadius: 0,
       marginLeft: 20, 
       '&:hover':{
           textDecoration: 'underline',
           background: 'transparent',
       },
           "&.active": {
      textDecoration: 'underline',
    },
  },
   
   active: {
       backgroundColor: '#555263',
   },

   iconLabelWrapper2: {
    flexDirection: "row-reverse"
  },
    labelContainer: {
    width: "auto",
    padding: 0
  },
    
    tab: {
        '& .MuiBox-root': {
            padding: '0px',
        },
        '& .MuiTab-textColorInherit': {
            opacity: 1,
        },
    },
    tabs: {
         "& .MuiTab-root": {
            minWidth: 'auto',
            minHeight: 'auto',
            paddingLeft: 15,
            paddingRight: 15,
            fontSize: 14,
            maxWidth: 'none',
        },
           '& .MuiTab-textColorInherit': {
            opacity: 1,
        },
         '& .MuiTab-labelIcon': {
            paddingTop: 0,
        },
    }
}));




function Navigation() {
  const globalClasses = globalUseStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyle();

     return (
                <Container className={globalClasses.navMargin}maxWidth={false} >
                <Grid item xs={12} container>
                <Grid item xs={3} container  style={{alignItems: 'flex-end'}}>
                <IconButton disableRipple style={{padding: 0, backgroundColor: 'transparent'}} color="inherit" aria-label="home">
                    <Link href={'/'}><img className={globalClasses.iconSpacing} src={logo} alt="logo"/></Link>
                    
                </IconButton>  
                </Grid>
                {isMatch ?
                ( <DrawerComponent /> ): 
                (

         
                  <Grid item xs={9} container justify="flex-end">
                    <Grid item xs={12} container  justify="flex-end">
                        
                        <List style={{display: 'flex', flexDirection: 'row', color: 'white'}}>
                            <ListItem to={'/support'} style={{paddingRight: 8}}component={RouterLink} className={globalClasses.utilityNav}>Support</ListItem>
                            <ListItem to={'/contact'} style={{paddingRight: 8}}component={RouterLink} className={globalClasses.utilityNav}>Contact us</ListItem>
                        </List>
                    </Grid>
            <Button disableRipple className={classes.buttonActive} component={NavLink} to="/solutions">Our Services and Solutions</Button>
            <Button disableRipple className={classes.buttonActive} component={NavLink} to="/work">Our Work</Button>
            <Button disableRipple className={classes.buttonActive} component={NavLink} to="/government">Government Services</Button>
            <Button disableRipple className={classes.buttonActive} component={NavLink} to="/who">Who We Are</Button>
            <Button disableRipple className={classes.buttonActive} component={NavLink} to="/careers">Careers</Button>

</Grid>
                )}
   </Grid>
   </Container>
    );
};

export default Navigation;